import React from "react";
import concessionFeeIcon from "../../../assets/images/concession-fee-logo.svg";
import datasourceIcon from "../../../assets/images/data-source-icon.svg";
import flightRosterIcon from "../../../assets/images/flight-roster-icon.svg";
import invoicingIcon from "../../../assets/images/invoicing-icon.svg";
import reportsIcon from "../../../assets/images/reports-icon.svg";
import settingIcon from "../../../assets/images/setting-icon.svg";
import specialOnboardingIcon from "../../../assets/images/special-onboarding-icon.svg";
import { getServiceUrls } from "../../../services/serviceUrls";
import { ACCOUNT_ROLE_STATUS } from "../../../utils/constants";
import "../CommercialAirlineHome.css";
import CardComponent from "./CardComponent";
const SERVICE_URL = getServiceUrls();

export const gridItems = [
  {
    title: "Invoices",
    icon: invoicingIcon,
    width: 23,
    height: 28,
    allowedRoles: [ACCOUNT_ROLE_STATUS[0].value],
  },
  {
    title: "Reports",
    icon: reportsIcon,
    width: 23,
    height: 28,
    allowedRoles: [],
  },
  {
    title: "Flight Roster",
    icon: flightRosterIcon,
    width: 26,
    height: 26,
    allowedRoles: [
      "AA_",
      ACCOUNT_ROLE_STATUS[0].value,
      ACCOUNT_ROLE_STATUS[1].value,
      "AA_OPS_ROLE",
    ],
  },
  {
    title: "Special Onboarding",
    icon: specialOnboardingIcon,
    width: 61,
    height: 26,
    allowedRoles: ["AA_", "AA_OPS_ROLE"],
  },
  {
    title: "Data Source",
    icon: datasourceIcon,
    width: 30,
    height: 24,
    allowedRoles: ["AA_"],
  },
  {
    title: "Account Maintenance",
    icon: settingIcon,
    width: 25,
    height: 25,
    allowedRoles: [ACCOUNT_ROLE_STATUS[0].value],
  },
  {
    title: "IATA - Invoices",
    icon: invoicingIcon,
    width: 23,
    height: 28,
    allowedRoles: [],
  },
  {
    title: "Concession Fee",
    icon: concessionFeeIcon,
    width: 23,
    height: 28,
    allowedRoles: [ACCOUNT_ROLE_STATUS[0].value, "AA_"],
  },
];

const GridComponent = ({ onClickCard, userRole }) => {
  const filteredItems = gridItems.filter((item) => {
    return !item.allowedRoles || item.allowedRoles.includes(userRole);
  });

  return (
    <div className="commercial-airline-grid-container">
      {filteredItems.map((item, index) => (
        <CardComponent
          key={index}
          item={item}
          onClickCard={() => onClickCard(gridItems.indexOf(item))}
        />
      ))}
    </div>
  );
};

export default GridComponent;
